import { z } from 'zod';
import { meta } from '../meta';

export const GalleryPropsSchema = z.object({
  images: z.array(z.string()).default([]).meta(meta({ label: '图片', setter: 'image', multiple: true })),
  autoplay: z.boolean().default(true).meta(meta({ label: '自动轮播', setter: 'switch' })),
  interval: z.number().min(1000).max(15000).default(3000).meta(meta({
    label: '间隔(ms)', setter: 'slider', min: 1000, max: 15000, step: 500,
    visible: (p) => p.autoplay === true,
  })),
  showDots: z.boolean().default(true).meta(meta({ label: '显示指示点', setter: 'switch' })),
  fit: z.enum(['cover', 'contain']).default('cover').meta(meta({
    label: '填充', setter: 'radio',
    options: [{ label: '裁切填满', value: 'cover' }, { label: '完整显示', value: 'contain' }],
  })),
});

export type GalleryProps = z.infer<typeof GalleryPropsSchema>;
